var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Servic nrk"},[_c('p',[_vm._v("组织架构")]),_c('img',{staticClass:"beij",attrs:{"src":"img/zx-5.jpg"}})])
}]

export { render, staticRenderFns }